"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var picker_service_1 = require("./picker.service");
exports.SLIDER_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return SlideControlComponent; }),
    multi: true
};
var SlideControlComponent = (function () {
    function SlideControlComponent(renderer, service) {
        this.renderer = renderer;
        this.service = service;
        this.min = 0;
        this.max = 100;
        this.isDragging = false;
        this.value = 0;
        this.onModelChange = function () {
        };
        this.onModelTouched = function () {
        };
    }
    SlideControlComponent.prototype.ngOnInit = function () {
        this.themeColor = this.service.dtTheme;
    };
    SlideControlComponent.prototype.ngOnDestroy = function () {
        this.dragListener();
        this.mouseUpListener();
    };
    SlideControlComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.dragListener = this.renderer.listen('document', 'mousemove', function (event) {
            if (_this.isDragging) {
                _this.handleChange(event);
            }
        });
        this.mouseUpListener = this.renderer.listen('document', 'mouseup', function (event) {
            if (_this.isDragging) {
                _this.isDragging = false;
            }
        });
    };
    SlideControlComponent.prototype.onMouseDown = function (event) {
        this.isDragging = true;
        this.updateSliderData();
        event.preventDefault();
    };
    SlideControlComponent.prototype.onTouchStart = function (event) {
        var touchObj = event.changedTouches[0];
        this.startHandleValue = this.handleValue;
        this.isDragging = true;
        this.startX = parseInt(touchObj.clientX, 10);
        this.sliderWidth = this.sliderElm.nativeElement.offsetWidth;
        event.preventDefault();
    };
    SlideControlComponent.prototype.onTouchMove = function (event) {
        var touchObj = event.changedTouches[0];
        var handleValue;
        handleValue = Math.floor(((parseInt(touchObj.clientX, 10) - this.startX) * 100) / (this.sliderWidth)) + this.startHandleValue;
        this.setValueFromHandle(event, handleValue);
        event.preventDefault();
    };
    SlideControlComponent.prototype.updateSliderData = function () {
        var rect = this.sliderElm.nativeElement.getBoundingClientRect();
        this.initX = rect.left;
        this.sliderWidth = this.sliderElm.nativeElement.offsetWidth;
        return;
    };
    SlideControlComponent.prototype.writeValue = function (value) {
        if (value !== this.value) {
            this.updateValue(value);
            this.updateHandleValue();
        }
    };
    SlideControlComponent.prototype.registerOnChange = function (fn) {
        this.onModelChange = fn;
    };
    SlideControlComponent.prototype.registerOnTouched = function (fn) {
        this.onModelTouched = fn;
    };
    SlideControlComponent.prototype.setDisabledState = function (isDisabled) {
    };
    SlideControlComponent.prototype.handleChange = function (event) {
        var handleValue = this.calculateHandleValue(event);
        this.setValueFromHandle(event, handleValue);
        return;
    };
    SlideControlComponent.prototype.calculateHandleValue = function (event) {
        return Math.floor(((event.pageX - this.initX) * 100) / (this.sliderWidth));
    };
    SlideControlComponent.prototype.setValueFromHandle = function (event, handleValue) {
        var newValue = this.getValueFromHandle(handleValue);
        this.handleValue = handleValue;
        this.updateValue(newValue, event);
        return;
    };
    SlideControlComponent.prototype.getValueFromHandle = function (handleValue) {
        return (this.max - this.min) * (handleValue / 100) + this.min;
    };
    SlideControlComponent.prototype.updateHandleValue = function () {
        if (this.value < this.min) {
            this.handleValue = 0;
        }
        else if (this.value > this.max) {
            this.handleValue = 100;
        }
        else {
            this.handleValue = (this.value - this.min) * 100 / (this.max - this.min);
        }
        return;
    };
    SlideControlComponent.prototype.updateValue = function (val, event) {
        if (val < this.min) {
            val = this.min;
            this.handleValue = 0;
        }
        else if (val > this.max) {
            val = this.max;
            this.handleValue = 100;
        }
        this.value = Math.floor(val);
        this.onModelChange(this.value);
    };
    return SlideControlComponent;
}());
SlideControlComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'app-slide-bar',
                template: "<div class=\"yk-slider\" [ngStyle]=\"style\" #slider><span class=\"yk-slider-bar\" [ngStyle]=\"{'width':handleValue + '%', backgroundColor: themeColor}\"></span> <span class=\"yk-slider-handle\" [ngStyle]=\"{'left':handleValue + '%'}\" (mousedown)=\"onMouseDown($event)\" (touchstart)=\"onTouchStart($event)\" (touchmove)=\"onTouchMove($event)\" (touchend)=\"isDragging=false\">{{value}}</span></div>",
                styles: ["*,::after,::before{-moz-box-sizing:border-box;box-sizing:border-box}.yk-slider{position:relative;height:4px;width:100px;background:#ccc;-moz-border-radius:10px;border-radius:10px;margin:0 auto;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.yk-slider-bar{position:absolute;left:0;width:0;height:100%;-moz-border-radius:10px;border-radius:10px}.yk-slider-handle{position:absolute;top:-10px;margin-left:-12.5px;width:25px;height:25px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;-moz-box-shadow:0 0 5px #ccc;box-shadow:0 0 5px #ccc;z-index:2;-moz-border-radius:100%;border-radius:100%;cursor:pointer}"],
                providers: [exports.SLIDER_VALUE_ACCESSOR],
            },] },
];
SlideControlComponent.ctorParameters = function () { return [
    { type: core_1.Renderer2, },
    { type: picker_service_1.PickerService, },
]; };
SlideControlComponent.propDecorators = {
    'min': [{ type: core_1.Input },],
    'max': [{ type: core_1.Input },],
    'style': [{ type: core_1.Input },],
    'sliderElm': [{ type: core_1.ViewChild, args: ['slider',] },],
};
exports.SlideControlComponent = SlideControlComponent;
//# sourceMappingURL=slider.component.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/slider.component.js
// module id = ../../../../ng-pick-datetime/slider.component.js
// module chunks = 15